// import SingleNews from '@/views/news/SingleNews'
import ImageHome from '@/views/images/ImageHome'
import SingleImage from '@/views/images/Image'
import ImagesList from '@/views/images/ImageList'
import ImageCreate from '@/views/images/ImageCreate'

export default {
  path: '/bilder',
  component: ImageHome,
  children: [
    {
      path: '',
      name: 'ImagesList',
      props: true,
      component: ImagesList,
      children: [
        {
          path: 'ny',
          name: 'createImage',
          props: true,
          component: ImageCreate,
        },
      ],
    },

    {
      path: ':id',
      name: 'Image',
      props: true,
      component: SingleImage,
    },
  ],
}
